import { z } from "zod";
/**
 * PATCH (kısmi güncelleme) şeması üretir: her alan isteğe bağlıdır ve VARSAYILAN DEĞERLER SÖKÜLÜR.
 *
 * Neden `.partial()` değil: Zod 4'te `.partial()` varsayılanları korur → `{ isActive: false, version: 3 }` gibi
 * bir istek ayrıştırılırken gönderilMEYEN `shortName`, `regionId`... alanları `null` varsayılanıyla doldurulur ve
 * servis bunları veritabanına yazar (sessiz veri kaybı). PATCH'te "gönderilmedi" ile "null gönderildi" FARKLIDIR.
 *
 * Varsayılan en dışta olmalıdır (`z.string().nullable().default(null)`); iç içe (pipe/transform arkasındaki)
 * varsayılanlar sökülemez — `patch.test.ts` her güncelleme şemasını bu hataya karşı denetler.
 */
export function patchOf(schema) {
    const shape = {};
    for (const [key, field] of Object.entries(schema.shape)) {
        let inner = field;
        while (inner instanceof z.ZodDefault)
            inner = inner.unwrap();
        shape[key] = inner.optional();
    }
    return z.object(shape);
}
//# sourceMappingURL=patch.js.map